<div class="unauthorized-page">
  <!-- Left Blue Hero Section -->
  <div class="blue-panel">
    <div class="content-box">
      <h1 class="title">{{ text.title }}</h1>
      <p class="subtitle">{{ text.description }}</p>
      <button class="btn-home" (click)="goHome()">
        {{ text.logoutButton }}
      </button>
    </div>
  </div>

  <!-- Right Graphic Section -->
  <div class="graphic-panel" aria-hidden="true">
    <div class="illustration-container">
      
      <!-- Top Window Card -->
      <div class="window-card">
        <div class="window-dots">
          <span class="dot dot-red"></span>
          <span class="dot dot-yellow"></span>
          <span class="dot dot-green"></span>
        </div>
        
        <div class="window-content">
          <div class="window-title">{{ text.accessList }}</div>
          <div class="status-row">
            <span class="skeleton-bar long"></span>
            <span class="unauthorized-badge">
              <span class="badge-dot"></span>
              {{ text.unauthorizedAccess }}
            </span>
          </div>
          <span class="skeleton-bar short"></span>
        </div>
      </div>

      <!-- Blue Lock Box -->
      <div class="lock-box">
        <svg class="lock-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
        </svg>
      </div>

      <!-- White Key Box -->
      <div class="key-box">
        <svg class="key-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 2l-2 2m-3 3l-4 4m0 0l-1.5-1.5M12 9l-1.5 1.5M15 6l-1.5 1.5M7 13a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"/>
        </svg>
      </div>

    </div>
  </div>
</div>